import { BindingPath } from "../../../../Engine/src/Engine/Core/CoreTypes";

export interface AttachInfoFileInfo {
    name: string;
    size: number;
    contentUri?: string;
}

export interface AttachInfo {
    contentUri?: string;
    file?: AttachInfoFileInfo;
    id: string;
    draftId?: string;
    nsId?: string;
    meta: {
        bindingPath: BindingPath;
        fileName: string;
        fileSize: number;
        instance?: string;
        pathToAttachment?: BindingPath;
        gfv?: string;
        attachmentDraftId?: string;
        // Api returns string
        progress: number | string;
        isConverted?: boolean;
        ndsTotalSum?: string | number;
        fileNamePatched?: string;
        format?: AttachFormat;
    };
}

export enum AttachFormat {
    PdfA1_1_4 = "PdfA1_1_4",
    Pdf = "Pdf",
}
